import { render, staticRenderFns } from "./PartitionView.vue?vue&type=template&id=53e8f744&"
import script from "./PartitionView.vue?vue&type=script&lang=js&"
export * from "./PartitionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports